import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getCurrentUser,
  updateCurrentUser,
  type UpdateCurrentUserParams,
} from "services/currentUser";

export const queryKeys = {
  currentUser: ["currentUser"],
};

type CurrentUserQuery = Awaited<ReturnType<typeof getCurrentUser>>;

export function currentUserQuery() {
  return {
    queryKey: queryKeys.currentUser,
    queryFn: () => getCurrentUser(),
    select: (data: CurrentUserQuery) => data.currentUser,
  };
}

export function useCurrentUser() {
  return useQuery(currentUserQuery());
}

export function useUpdateCurrentUser() {
  const queryClient = useQueryClient();

  return useMutation((params: Partial<UpdateCurrentUserParams>) => updateCurrentUser(params), {
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.currentUser);
    },
  });
}
